import { MAlert, MText } from '../../../../../../components/Monetize';

export const CrmFieldsUnavailableAlert = ({
  crmLabel,
}: {
  crmLabel: string;
}) => (
  <MAlert type="warning">
    <MText>
      Field data from {crmLabel} is unavailable, so your saved mappings are
      shown read-only. You can edit them again once the {crmLabel} connection is
      working.
    </MText>
  </MAlert>
);
